/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "In May of this year I made myself a promise. I looked at my schedule,\nat my web site, and at my my life in general and realized I needed a\nchange. Since ", React.createElement(_components.a, {
    href: "/2005/09/02/michigan-orientation/",
    title: "Highlights of the 2005 University of Michigan Orientation"
  }, "beginning grad school"), " I had been running on fumes.\nmy whole life seemed fifteen minutes later than the rest of the world.\nI stopped blogging, stopped experimenting and stopped learning how to\nimprove my craft."), "\n", React.createElement(_components.p, null, "This redesign is my shot in the arm."), "\n", React.createElement(_components.p, null, "This design, codenamed “Roland”, it is a commitment to my work and\nto helping share my experience. Any success I've had in this medium\nhas been achieved by ", React.createElement(_components.a, {
    href: "http://www.quirksmode.org/",
    title: "Quirksmode - For all you browser quirks"
  }, "standing"), " ", React.createElement(_components.a, {
    href: "http://tantek.com/",
    title: "Tantek's Thoughts"
  }, "on"), " ", React.createElement(_components.a, {
    href: "http://www.themaninblue.com/",
    title: "The Man in Blue > Distilling fine web design since 1863"
  }, "the"), "\n", React.createElement(_components.a, {
    href: "http://dustindiaz.com/",
    title: "Dustin Diaz: Standards with Imagination"
  }, "shoulders"), " ", React.createElement(_components.a, {
    href: "http://ln.hixie.ch/",
    title: "Hixie's Natural Log"
  }, "of"), " ", React.createElement(_components.a, {
    href: "http://www.annevankesteren.nl/",
    title: "Anne’s Weblog"
  }, "giants"), ". Now is (hopefully)\nmy turn to reciprocate."), "\n", React.createElement(_components.p, null, "My immediate apologies if I have broken anything. Please ", React.createElement(_components.a, {
    href: "/contact/",
    title: "My web-based contact form."
  }, "contact"), "\nme if you notice something amiss. I've tested as much as I can—the\ntime for procrastination is done."), "\n", React.createElement(_components.p, null, "Welcome to the bigger, badder, more flippant RyanCannon.com. I hope\nyou enjoy."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
